import { Box, Flex, xcss } from '@atlaskit/primitives';

import { RightHandSideProps } from '../../../common/types.tsx';
import {
	useGetSelectedCodingAgentAvatarsFromSearchParams,
	useIllustrationViewType,
} from '../../../controllers/index';
import { BoardColumnsSvg } from '../../assets/board-columns-svg.tsx';
import { ProjectSvg, type Injections } from '../../assets/project-svg.tsx';
import { JfindOnboardIllustrationRefresh } from '../../variant/jfind-onboard-illustration-refresh/jfind-onboard-illustration-refresh';

import { ColumnHighlight } from './column-highlight.tsx';

export const RightHandSidePageBoardColumns = ({
	projectName,
	columnNames,
	isIllustrationRefresh,
}: RightHandSideProps & { columnNames: string[] }) => {
	const illustrationViewType = useIllustrationViewType();

	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams();
	const injections: Injections = {
		additionalObject: ColumnHighlight,
		svgBody: BoardColumnsSvg({
			columnNames,
			assignedAgents,
		}),
	};

	if (isIllustrationRefresh) {
		return (
			<Box xcss={illustrationRefreshContainerStyles}>
				<JfindOnboardIllustrationRefresh
					projectName={projectName}
					viewType={illustrationViewType}
					columnNames={columnNames}
				/>
			</Box>
		);
	}

	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="board" injections={injections} />
		</Flex>
	);
};
const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});

const illustrationRefreshContainerStyles = xcss({
	height: '100%',
	overflow: 'hidden',
});
